// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Variables */
:root {
  --compact-primary: #2563eb;
  --compact-primary-light: #dbeafe;
  --compact-secondary: #f8fafc;
  --compact-text: #1e293b;
  --compact-text-light: #64748b;
  --compact-border: #e2e8f0;
  --compact-accent-blue: #3b82f6;
  --compact-accent-purple: #8b5cf6;
  --compact-white: #ffffff;
  --compact-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.05);
  --compact-card-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  --compact-success: #22c55e;
  --compact-warning: #f97316;
  --compact-warning-dark: #ea580c;
  --compact-danger: #ef4444;
}

.compact-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 0;
}

.compact-modal-container {
  background: var(--compact-white);
  border-radius: 8px;
  box-shadow: var(--compact-shadow);
  width: 100vw;
  max-width: 97vw;
  height: 100vh;
  max-height: 97vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  transform: translateY(0);
  animation: compact-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes compact-modal-appear {
  to {
    transform: translateY(0);
  }
}
/* Filter Dropdown Styles */
.company-modal-filter-dropdown {
  position: absolute;
  top: 100%;
  background: var(--compact-white);
  border: 1px solid var(--compact-border);
  border-radius: 8px;
  box-shadow: var(--compact-shadow);
  z-index: 1001;
  width: 400px;
  padding: 16px;
  margin-top: 8px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}
.company-modal-filter-dropdown .filter-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--compact-text);
  margin-bottom: 6px;
}
.company-modal-filter-dropdown .filter-group select,
.company-modal-filter-dropdown .filter-group input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  font-size: 14px;
  color: var(--compact-text);
  background: var(--compact-white);
  transition: border-color 0.2s ease;
}
.company-modal-filter-dropdown .filter-group select:focus,
.company-modal-filter-dropdown .filter-group input:focus {
  outline: none;
  border-color: var(--compact-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.company-modal-filter-dropdown .filter-group .filter-date-row {
  display: flex;
  gap: 8px;
}
.company-modal-filter-dropdown .filter-group .filter-date-row input {
  flex: 1 1;
}
.company-modal-filter-dropdown .filter-actions {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--compact-border);
  transform: translateY(15px);
  position: sticky;
  bottom: 4px;
  background: white;
  z-index: 100;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn,
.company-modal-filter-dropdown .filter-actions .filter-close-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn {
  background: var(--compact-danger);
  color: white;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn:hover {
  background: #dc2626;
}
.company-modal-filter-dropdown .filter-actions .filter-close-btn {
  background: var(--compact-secondary);
  color: var(--compact-text);
}
.company-modal-filter-dropdown .filter-actions .filter-close-btn:hover {
  background: #f1f5f9;
}

.compact-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--compact-border);
}

.compact-modal-content {
  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  max-height: 300px;
  opacity: 1;
  overflow: hidden;
  transform-origin: top;
  transform: translateY(0);
  will-change: max-height, opacity, transform;
}
.compact-modal-content.collapsed {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
  transform: translateY(-10px);
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

.compact-modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--compact-text);
  margin: 0;
}
.compact-modal-header h3 .company-name {
  color: var(--compact-primary);
  font-weight: 500;
  font-size: 16px;
}

.compact-close-button {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: var(--compact-text-light);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.compact-close-button:hover {
  color: var(--compact-text);
  background: var(--compact-secondary);
}

/* Image-style stats container */
.image-style-stats-container {
  display: flex;
  gap: 20px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  overflow-x: auto;
  align-items: stretch;
}

/* Individual stat cards */
.image-style-stat-card {
  flex: 1 1;
  min-width: 180px;
  background: white;
  border-radius: 12px;
  padding: 12px;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

/* Icon styling */
.image-style-stat-card .head-img {
  display: flex;
  align-items: center;
  gap: 10px;
}
.image-style-stat-card .head-img .stat-icon {
  width: 30px;
  height: 30px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
}

/* Content area */
.image-style-stat-card .stat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Typography */
.image-style-stat-card .stat-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.image-style-stat-card .stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.image-style-stat-card .number-value-stat-comp {
  margin-top: 0.8rem;
}

.image-style-stat-card .stat-sublabel {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.image-style-stat-card .stat-percentage {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-top: 2px;
}

/* Progress bars */
.image-style-stat-card .stat-progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  margin: 8px 0 4px 0;
}

.image-style-stat-card .stat-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.6s ease-out;
}

/* Specific card colors */
.users-card .stat-icon {
  background: #7c3aed;
}

.users-card .stat-progress-fill.users-progress {
  background: #7c3aed;
}

.cases-card .stat-icon {
  background: #2563eb;
}

.cases-card .stat-progress-fill.cases-progress {
  background: #2563eb;
}

.highcourt-card .stat-icon {
  background: #059669;
}

.highcourt-card .stat-progress-fill.highcourt-progress {
  background: #059669;
}

.districtcourt-card .stat-icon {
  background: #dc2626;
}

.districtcourt-card .stat-progress-fill.districtcourt-progress {
  background: #dc2626;
}

.othercourts-card .stat-icon {
  background: #7c2d12;
}

.othercourts-card .stat-progress-fill.othercourts-progress {
  background: #7c2d12;
}

.supremecourt-card .stat-icon {
  background: #6d28d9;
}

/* Footer with integrated pagination */
.compact-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--compact-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.compact-modal-footer .footer-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.compact-modal-footer button {
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
}

.compact-modal-footer button:last-child {
  background: var(--compact-border);
  color: var(--compact-text);
}

.compact-modal-footer button:last-child:hover {
  background: #cbd5e1;
}

.update-cases-btn {
  background: var(--primary-color);
  color: var(--compact-white);
}

.update-cases-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.update-cases-btn:disabled {
  background: var(--compact-text-light);
  cursor: not-allowed;
  opacity: 0.6;
}

/* Pagination in Footer Styles */
.manage-cases-pagination-compact {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.pagination-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pagination-select {
  padding: 6px 10px;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  font-size: 13px;
  color: var(--compact-text);
  background: var(--compact-white);
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.pagination-select:focus {
  outline: none;
  border-color: var(--compact-primary);
}

.pagination-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination-btn-compact {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  background: var(--compact-white);
  color: var(--compact-text);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn-compact:hover:not(:disabled) {
  background: var(--compact-primary-light);
  border-color: var(--compact-primary);
  color: var(--compact-primary);
}

.pagination-btn-compact:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-info-compact {
  font-size: 13px;
  color: var(--compact-text);
  font-weight: 500;
  min-width: 50px;
  text-align: center;
}

.pagination-total-compact {
  font-size: 12px;
  color: var(--compact-text-light);
  font-weight: 500;
}

/* Loading and Error States */
.compact-modal-loading,
.compact-modal-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
}

.compact-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--compact-border);
  border-top: 3px solid var(--compact-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.compact-modal-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--compact-text-light);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.compact-modal-error p {
  color: #dc2626;
  margin-bottom: 16px;
  font-size: 14px;
}

.compact-modal-error button {
  background: var(--compact-primary);
  color: var(--compact-white);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

/* Updated Modern Compact Manage Cases Section */
.manage-cases-section {
  padding: 16px 20px;
  overflow-y: auto;
  border-radius: 12px;
  min-height: 0;
  flex: 1 1;
}

/* Compact Modern Tab System */
.manage-cases-tabs {
  display: flex;
  gap: 2px;
  margin-bottom: 12px;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.manage-cases-tab {
  flex: 1 1;
  padding: 8px 14px;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  white-space: nowrap;
}

.manage-cases-tab.active {
  background: white;
  color: var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.manage-cases-tab:hover:not(.active) {
  color: #475569;
  background: rgba(255, 255, 255, 0.5);
}

/* Compact Sub-tabs */
.manage-cases-subtabs {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
}

.manage-cases-subtab {
  padding: 8px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.manage-cases-subtab.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.manage-cases-subtab:hover:not(.active) {
  border-color: #cbd5e1;
  background: #f1f5f9;
}

/* Compact Cases List */
.manage-cases-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  content-visibility: auto; /* Skips rendering items outside the viewport */
  contain-intrinsic-size: 80px;
}

/* Compact Case Cards */
.manage-case-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 60px;
}

.manage-case-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.manage-case-card.focused {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  transform: translateY(-1px);
}

/* Disabled/Assigned state */
.manage-case-card.assigned {
  background: #f8f9fa;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.manage-case-card.assigned:hover {
  border-color: #e2e8f0;
  box-shadow: none;
  transform: none;
}
.manage-case-card.assigned .case-checkbox {
  cursor: not-allowed;
  opacity: 0.5;
}

.manage-case-checkbox {
  position: static;
  flex-shrink: 0;
  margin: 0;
}

.case-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--primary-color);
}

.manage-case-details {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0;
  min-height: auto;
}

.manage-case-main-info {
  flex: 1 1;
  min-width: 0;
}

.manage-case-parties {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.manage-case-secondary-info {
  display: flex;
  gap: 16px;
  margin: 0;
  align-items: center;
}

.manage-case-info-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
}

.manage-case-label {
  font-weight: 500;
  color: #64748b;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: auto;
}

.manage-case-info-item span:last-child {
  color: #475569;
  font-weight: 500;
  font-size: 11px;
}

.manage-case-right-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  border: none;
  flex-shrink: 0;
}

.manage-case-status {
  display: flex;
  align-items: center;
}

.manage-case-status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: 1px solid;
  white-space: nowrap;
}

.manage-case-status-badge.disposed {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.manage-case-status-badge.pending {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a;
}

.manage-case-status-badge.na {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.manage-case-date {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 10px;
}

.manage-case-date .manage-case-label {
  margin: 0;
  font-size: 9px;
}

.manage-case-date span:last-child {
  color: #1e293b;
  font-weight: 600;
  font-size: 10px;
  white-space: nowrap;
}

.manage-cases-content {
  position: relative; /* Critical for anchoring the loader */
  min-height: 400px; /* Critical: Prevents footer from jumping up */
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.manage-cases-loading {
  position: absolute !important; /* Force it to sit ON TOP of the list */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Make it a white transparent glass effect instead of the gray box */
  background: rgba(255, 255, 255, 0.85) !important;
  border: none !important; /* Remove the dashed border from existing styles */
  border-radius: 0 !important;
  z-index: 50; /* Ensure it is above the rows */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Loading, Error, Empty States */
.manage-cases-error,
.manage-cases-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
}

.manage-cases-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.manage-cases-loading p,
.manage-cases-empty p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.manage-cases-error p {
  color: #dc2626;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 500;
}

.manage-cases-error button {
  background: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.manage-cases-error button:hover {
  background: #b91c1c;
}

.options-courts {
  display: flex;
  gap: 6px;
}

/* Selection Counter Styles */
.selection-counter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

/* Keyboard Navigation Hint */
.keyboard-nav-hint {
  padding: 6px 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  margin-bottom: 12px;
  text-align: center;
}
.keyboard-nav-hint small {
  color: #1e40af;
  font-size: 11px;
  font-weight: 500;
}
.keyboard-nav-hint kbd {
  display: inline-block;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  color: #1e293b;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin: 0 2px;
}

.selection-count {
  font-weight: 600;
  color: #475569;
}

.selection-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
}

.select-all-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

/* Base styles for new action buttons */
.select-all-cases-btn,
.clear-page-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.select-all-cases-btn:disabled,
.clear-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Specific styles for the new buttons */
.select-all-cases-btn {
  background: var(--compact-primary);
  color: white;
}
.select-all-cases-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.clear-page-btn {
  background: var(--compact-warning);
  color: white;
}
.clear-page-btn:hover:not(:disabled) {
  background: var(--compact-warning-dark);
}

.clear-selection-btn {
  padding: 4px 8px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.clear-selection-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

/* Limit Exceeded Modal Styles */
.limit-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 16px;
}

.limit-modal-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  animation: limit-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes limit-modal-appear {
  from {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.limit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fef2f2;
  border-bottom: 1px solid #fecaca;
}

.limit-modal-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #dc2626;
  margin: 0;
}

.limit-modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #dc2626;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.limit-modal-close:hover {
  background: rgba(220, 38, 38, 0.1);
}

.limit-modal-content {
  padding: 20px;
  text-align: center;
}

.limit-modal-content p {
  margin: 0 0 12px 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

.limit-modal-content p:last-child {
  margin-bottom: 0;
}

.limit-modal-content strong {
  color: #dc2626;
  font-weight: 600;
}

.limit-modal-footer {
  padding: 16px 20px;
  background: #f8fafc;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.limit-modal-upgrade-btn {
  padding: 8px 24px;
  background: #ff7e5f;
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.limit-modal-btn {
  padding: 8px 24px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.limit-modal-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

.sa-search-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.sa-search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.sa-search-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: white;
}

.sa-search-loading {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary-color);
}

.sa-spinner {
  animation: spin 1s linear infinite;
}

.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--border-light);
  color: var(--text-medium);
  position: relative;
}
.icon-btn svg {
  width: 16px;
  height: 16px;
}
.icon-btn.active {
  background: var(--primary-light);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.icon-btn.active-filter {
  background: var(--primary-light-bg);
}
.icon-btn .filter-indicator {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
  border: 2px solid white;
}

/* Responsive Adjustments */
@media (max-width: 1200px) {
  .compact-modal-container {
    max-width: 900px;
  }
  .image-style-stats-container {
    flex-wrap: wrap;
  }
  .image-style-stat-card {
    min-width: 160px;
  }
}
@media (max-width: 900px) {
  .manage-cases-section {
    padding: 16px;
  }
  .manage-cases-tabs {
    flex-direction: column;
    gap: 4px;
  }
  .manage-cases-tab {
    padding: 8px 12px;
  }
  .manage-case-details {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .manage-case-secondary-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .manage-case-right-info {
    width: 100%;
    justify-content: space-between;
  }
  .image-style-stats-container {
    flex-direction: column;
    gap: 12px;
  }
  .image-style-stat-card {
    min-width: auto;
  }
  .compact-modal-content {
    max-height: 1000px;
  }
}
@media (max-width: 768px) {
  .selection-counter {
    flex-direction: column;
    align-items: flex-start;
  }
  .selection-actions {
    width: 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}
@media (max-width: 600px) {
  .manage-case-card {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .manage-case-checkbox {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  .manage-case-details {
    width: 100%;
    padding-right: 30px;
  }
  .manage-case-parties {
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .selection-counter {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    text-align: center;
  }
  .clear-selection-btn {
    width: 100%;
    padding: 6px 12px;
  }
  .limit-modal-container {
    max-width: 350px;
    margin: 0 16px;
  }
  .compact-modal-footer {
    flex-direction: column;
    gap: 12px;
  }
  .manage-cases-pagination-compact {
    width: 100%;
  }
  .footer-buttons {
    width: 100%;
    justify-content: stretch;
  }
  .footer-buttons button {
    flex: 1 1;
  }
  .image-style-stat-card {
    padding: 16px 12px;
    gap: 10px;
  }
  .image-style-stat-card .stat-icon {
    width: 40px;
    height: 40px;
  }
  .image-style-stat-card .stat-value {
    font-size: 28px;
  }
}
@media (max-width: 500px) {
  .manage-cases-section {
    padding: 16px;
  }
  .manage-cases-tabs {
    flex-direction: column;
  }
  .manage-cases-tab {
    text-align: center;
  }
  .manage-case-card {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CompanyModalLimit/CompanyModalLimit.scss"],"names":[],"mappings":"AAAA,oBAAA;AACA;EACE,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;EACA,gCAAA;EACA,wBAAA;EACA;uCAAA;EAEA,oDAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AACF;;AAEA;EACE,gCAAA;EACA,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,+EAAA;AACF;;AAGA;EACE;IACE,wBAAA;EAAF;AACF;AAGA,2BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAKI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAHN;AAMI;;EAEE,WAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,kCAAA;AAJN;AAMM;;EACE,aAAA;EACA,oCAAA;EACA,4CAAA;AAHR;AAOI;EACE,aAAA;EACA,QAAA;AALN;AAOM;EACE,SAAA;AALR;AAUE;EACE,aAAA;EACA,QAAA;EACA,8BAAA;EACA,iBAAA;EACA,2CAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AARJ;AAUI;;EAEE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AARN;AAWI;EACE,iCAAA;EACA,YAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,oCAAA;EACA,0BAAA;AAXN;AAaM;EACE,mBAAA;AAXR;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AAdF;;AAiBA;EACE,kDAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,2CAAA;AAdF;AAgBE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;EACA,kDAAA;AAdJ;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAfF;AAiBE;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AAfJ;;AAmBA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,0BAAA;EACA,oCAAA;AAhBF;;AAmBA,gCAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAhBF;;AAmBA,0BAAA;AACA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,yCAAA;EACA,qDAAA;EACA,gBAAA;AAhBF;;AAmBA,iBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhBF;AAiBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAfJ;;AAmBA,iBAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhBF;;AAmBA,eAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAhBF;;AAmBA,kBAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,kBAAA;EACA,+BAAA;AAhBF;;AAmBA,yBAAA;AACA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAoBA,sCAAA;AACA;EACE,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,iCAAA;EACA,0BAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,gCAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;EACE,qCAAA;EACA,mBAAA;EACA,YAAA;AAjBF;;AAoBA,gCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,eAAA;EACA,kCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,oCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;EACA,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,wCAAA;EACA,oCAAA;EACA,6BAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAjBF;;AAoBA,6BAAA;AACA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,4CAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,eAAA;EACA,gCAAA;AAjBF;;AAoBA;EACE;IACE,uBAAA;EAjBF;EAmBA;IACE,yBAAA;EAjBF;AACF;AAoBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,kCAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAlBF;;AAqBA,gDAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAlBF;;AAqBA,8BAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAlBF;;AAqBA;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,2BAAA;EACA,wCAAA;AAlBF;;AAqBA;EACE,cAAA;EACA,oCAAA;AAlBF;;AAqBA,qBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAlBF;;AAqBA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAlBF;;AAqBA;EACE,gCAAA;EACA,YAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,mBAAA;AAlBF;;AAqBA,uBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA,EAAA,+CAAA;EACA,4BAAA;AAlBF;;AAqBA,uBAAA;AACA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,6CAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;EACA,2BAAA;AAlBF;;AAqBA,4BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAlBF;AAoBE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,YAAA;AAnBJ;;AAuBA;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AApBF;;AAuBA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,SAAA;EACA,YAAA;AApBF;;AAuBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AApBF;;AAuBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AApBF;;AAuBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AApBF;;AAuBA;EACE,SAAA;EACA,cAAA;AApBF;;AAuBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AApBF;;AAsBA;EACE,kBAAA,EAAA,sCAAA;EACA,iBAAA,EAAA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,6BAAA,EAAA,uCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAEA,qEAAA;EACA,gDAAA;EACA,uBAAA,EAAA,kDAAA;EACA,2BAAA;EAEA,WAAA,EAAA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AArBF;;AAwBA,iCAAA;AAEA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAtBF;;AAyBA;;EAEE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,mBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,QAAA;AAtBF;;AAyBA,6BAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;AAtBF;;AAyBA,6BAAA;AACA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAtBF;AAwBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAtBJ;AAyBE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;AAvBJ;;AA2BA;EACE,gBAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAxBF;;AA2BA,uCAAA;AACA;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAxBF;AA0BE;;EACE,YAAA;EACA,mBAAA;AAvBJ;;AA2BA,wCAAA;AACA;EACE,kCAAA;EACA,YAAA;AAxBF;AA0BE;EACE,mBAAA;AAxBJ;;AA4BA;EACE,kCAAA;EACA,YAAA;AAzBF;AA2BE;EACE,uCAAA;AAzBJ;;AA6BA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,2BAAA;AA1BF;;AA6BA,gCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,mBAAA;EACA,qFAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6EAAA;AA1BF;;AA6BA;EACE;IACE,uCAAA;IACA,UAAA;EA1BF;EA4BA;IACE,iCAAA;IACA,UAAA;EA1BF;AACF;AA6BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA3BF;;AA8BA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,kCAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,cAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,mBAAA;EACA,uDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AA3BF;;AA8BA;EACE,kCAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,YAAA;AA3BJ;AA8BE;EACE,gCAAA;EACA,2BAAA;EACA,sCAAA;AA5BJ;AA+BE;EACE,mCAAA;AA7BJ;AAgCE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;AA9BJ;;AAkCA,2BAAA;AACA;EACE;IACE,gBAAA;EA/BF;EAkCA;IACE,eAAA;EAhCF;EAmCA;IACE,gBAAA;EAjCF;AACF;AAoCA;EACE;IACE,aAAA;EAlCF;EAqCA;IACE,sBAAA;IACA,QAAA;EAnCF;EAsCA;IACE,iBAAA;EApCF;EAuCA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EArCF;EAwCA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAtCF;EAyCA;IACE,WAAA;IACA,8BAAA;EAvCF;EA0CA;IACE,sBAAA;IACA,SAAA;EAxCF;EA2CA;IACE,eAAA;EAzCF;EA4CA;IACE,kBAAA;EA1CF;AACF;AA6CA;EACE;IACE,sBAAA;IACA,uBAAA;EA3CF;EA6CA;IACE,WAAA;IACA,2BAAA;IACA,cAAA;EA3CF;AACF;AA8CA;EACE;IACE,kBAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;EA5CF;EA+CA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EA7CF;EAgDA;IACE,WAAA;IACA,mBAAA;EA9CF;EAiDA;IACE,mBAAA;IACA,iBAAA;IACA,sBAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;EA/CF;EAkDA;IACE,sBAAA;IACA,QAAA;IACA,oBAAA;IACA,kBAAA;EAhDF;EAmDA;IACE,WAAA;IACA,iBAAA;EAjDF;EAoDA;IACE,gBAAA;IACA,cAAA;EAlDF;EAqDA;IACE,sBAAA;IACA,SAAA;EAnDF;EAsDA;IACE,WAAA;EApDF;EAuDA;IACE,WAAA;IACA,wBAAA;EArDF;EAwDA;IACE,SAAA;EAtDF;EAyDA;IACE,kBAAA;IACA,SAAA;EAvDF;EA0DA;IACE,WAAA;IACA,YAAA;EAxDF;EA2DA;IACE,eAAA;EAzDF;AACF;AA4DA;EACE;IACE,aAAA;EA1DF;EA6DA;IACE,sBAAA;EA3DF;EA8DA;IACE,kBAAA;EA5DF;EA+DA;IACE,aAAA;EA7DF;AACF","sourcesContent":["/* Color Variables */\n:root {\n  --compact-primary: #2563eb;\n  --compact-primary-light: #dbeafe;\n  --compact-secondary: #f8fafc;\n  --compact-text: #1e293b;\n  --compact-text-light: #64748b;\n  --compact-border: #e2e8f0;\n  --compact-accent-blue: #3b82f6;\n  --compact-accent-purple: #8b5cf6;\n  --compact-white: #ffffff;\n  --compact-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n    0 8px 10px -6px rgba(0, 0, 0, 0.05);\n  --compact-card-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  --compact-success: #22c55e;\n  --compact-warning: #f97316;\n  --compact-warning-dark: #ea580c;\n  --compact-danger: #ef4444;\n}\n\n.compact-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 0;\n}\n\n.compact-modal-container {\n  background: var(--compact-white);\n  border-radius: 8px;\n  box-shadow: var(--compact-shadow);\n  width: 100vw;\n  max-width: 97vw;\n  height: 100vh;\n  max-height: 97vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  transform: translateY(0);\n  animation: compact-modal-appear 0.3s forwards\n    cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes compact-modal-appear {\n  to {\n    transform: translateY(0);\n  }\n}\n\n/* Filter Dropdown Styles */\n.company-modal-filter-dropdown {\n  position: absolute;\n  top: 100%;\n  background: var(--compact-white);\n  border: 1px solid var(--compact-border);\n  border-radius: 8px;\n  box-shadow: var(--compact-shadow);\n  z-index: 1001;\n  width: 400px;\n  padding: 16px;\n  margin-top: 8px;\n  max-height: 250px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  \n\n  .filter-group {\n    label {\n      display: block;\n      font-size: 14px;\n      font-weight: 500;\n      color: var(--compact-text);\n      margin-bottom: 6px;\n    }\n\n    select,\n    input {\n      width: 100%;\n      padding: 8px 12px;\n      border: 1px solid var(--compact-border);\n      border-radius: 6px;\n      font-size: 14px;\n      color: var(--compact-text);\n      background: var(--compact-white);\n      transition: border-color 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: var(--compact-primary);\n        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n      }\n    }\n\n    .filter-date-row {\n      display: flex;\n      gap: 8px;\n\n      input {\n        flex: 1;\n      }\n    }\n  }\n\n  .filter-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: space-between;\n    padding-top: 16px;\n    border-top: 1px solid var(--compact-border);\n    transform: translateY(15px);\n    position: sticky;\n    bottom: 4px;\n    background: white;\n    z-index: 100;\n\n    .filter-clear-btn,\n    .filter-close-btn {\n      padding: 8px 16px;\n      border: none;\n      border-radius: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n    }\n\n    .filter-clear-btn {\n      background: var(--compact-danger);\n      color: white;\n\n      &:hover {\n        background: #dc2626;\n      }\n    }\n\n    .filter-close-btn {\n      background: var(--compact-secondary);\n      color: var(--compact-text);\n\n      &:hover {\n        background: #f1f5f9;\n      }\n    }\n  }\n}\n\n.compact-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--compact-border);\n}\n\n.compact-modal-content {\n  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);\n  max-height: 300px;\n  opacity: 1;\n  overflow: hidden;\n  transform-origin: top;\n  transform: translateY(0);\n  will-change: max-height, opacity, transform;\n\n  &.collapsed {\n    max-height: 0;\n    opacity: 0;\n    margin-bottom: 0;\n    transform: translateY(-10px);\n    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);\n  }\n}\n\n.compact-modal-header h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--compact-text);\n  margin: 0;\n\n  .company-name {\n    color: var(--compact-primary);\n    font-weight: 500;\n    font-size: 16px;\n  }\n}\n\n.compact-close-button {\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  line-height: 1;\n  color: var(--compact-text-light);\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.compact-close-button:hover {\n  color: var(--compact-text);\n  background: var(--compact-secondary);\n}\n\n/* Image-style stats container */\n.image-style-stats-container {\n  display: flex;\n  gap: 20px;\n  padding: 20px;\n  background: #f8fafc;\n  border-radius: 12px;\n  overflow-x: auto;\n  align-items: stretch;\n}\n\n/* Individual stat cards */\n.image-style-stat-card {\n  flex: 1;\n  min-width: 180px;\n  background: white;\n  border-radius: 12px;\n  padding: 12px;\n  gap: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n}\n\n/* Icon styling */\n.image-style-stat-card .head-img {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .stat-icon {\n    width: 30px;\n    height: 30px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    color: white;\n  }\n}\n\n/* Content area */\n.image-style-stat-card .stat-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Typography */\n.image-style-stat-card .stat-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.image-style-stat-card .stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1;\n}\n\n.image-style-stat-card .number-value-stat-comp {\n  margin-top: 0.8rem;\n}\n\n.image-style-stat-card .stat-sublabel {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.image-style-stat-card .stat-percentage {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n/* Progress bars */\n.image-style-stat-card .stat-progress-bar {\n  height: 6px;\n  background: #e2e8f0;\n  border-radius: 3px;\n  overflow: hidden;\n  margin: 8px 0 4px 0;\n}\n\n.image-style-stat-card .stat-progress-fill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.6s ease-out;\n}\n\n/* Specific card colors */\n.users-card .stat-icon {\n  background: #7c3aed;\n}\n\n.users-card .stat-progress-fill.users-progress {\n  background: #7c3aed;\n}\n\n.cases-card .stat-icon {\n  background: #2563eb;\n}\n\n.cases-card .stat-progress-fill.cases-progress {\n  background: #2563eb;\n}\n\n.highcourt-card .stat-icon {\n  background: #059669;\n}\n\n.highcourt-card .stat-progress-fill.highcourt-progress {\n  background: #059669;\n}\n\n.districtcourt-card .stat-icon {\n  background: #dc2626;\n}\n\n.districtcourt-card .stat-progress-fill.districtcourt-progress {\n  background: #dc2626;\n}\n\n.othercourts-card .stat-icon {\n  background: #7c2d12;\n}\n\n.othercourts-card .stat-progress-fill.othercourts-progress {\n  background: #7c2d12;\n}\n\n.supremecourt-card .stat-icon {\n  background: #6d28d9;\n}\n\n\n/* Footer with integrated pagination */\n.compact-modal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid var(--compact-border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.compact-modal-footer .footer-buttons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.compact-modal-footer button {\n  padding: 8px 18px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border: none;\n}\n\n.compact-modal-footer button:last-child {\n  background: var(--compact-border);\n  color: var(--compact-text);\n}\n\n.compact-modal-footer button:last-child:hover {\n  background: #cbd5e1;\n}\n\n.update-cases-btn {\n  background: var(--primary-color);\n  color: var(--compact-white);\n}\n\n.update-cases-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.update-cases-btn:disabled {\n  background: var(--compact-text-light);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Pagination in Footer Styles */\n.manage-cases-pagination-compact {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.pagination-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pagination-select {\n  padding: 6px 10px;\n  border: 1px solid var(--compact-border);\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--compact-text);\n  background: var(--compact-white);\n  cursor: pointer;\n  transition: border-color 0.2s ease;\n}\n\n.pagination-select:focus {\n  outline: none;\n  border-color: var(--compact-primary);\n}\n\n.pagination-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pagination-btn-compact {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 1px solid var(--compact-border);\n  border-radius: 6px;\n  background: var(--compact-white);\n  color: var(--compact-text);\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pagination-btn-compact:hover:not(:disabled) {\n  background: var(--compact-primary-light);\n  border-color: var(--compact-primary);\n  color: var(--compact-primary);\n}\n\n.pagination-btn-compact:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pagination-info-compact {\n  font-size: 13px;\n  color: var(--compact-text);\n  font-weight: 500;\n  min-width: 50px;\n  text-align: center;\n}\n\n.pagination-total-compact {\n  font-size: 12px;\n  color: var(--compact-text-light);\n  font-weight: 500;\n}\n\n/* Loading and Error States */\n.compact-modal-loading,\n.compact-modal-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 40px;\n  text-align: center;\n}\n\n.compact-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--compact-border);\n  border-top: 3px solid var(--compact-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.compact-modal-loading p {\n  margin: 0;\n  font-size: 14px;\n  color: var(--compact-text-light);\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.compact-modal-error p {\n  color: #dc2626;\n  margin-bottom: 16px;\n  font-size: 14px;\n}\n\n.compact-modal-error button {\n  background: var(--compact-primary);\n  color: var(--compact-white);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Updated Modern Compact Manage Cases Section */\n.manage-cases-section {\n  padding: 16px 20px;\n  overflow-y: auto;\n  border-radius: 12px;\n  min-height: 0;\n  flex: 1;\n}\n\n/* Compact Modern Tab System */\n.manage-cases-tabs {\n  display: flex;\n  gap: 2px;\n  margin-bottom: 12px;\n  background: #f1f5f9;\n  padding: 3px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.manage-cases-tab {\n  flex: 1;\n  padding: 8px 14px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.manage-cases-tab.active {\n  background: white;\n  color: var(--primary-color);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.manage-cases-tab:hover:not(.active) {\n  color: #475569;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n/* Compact Sub-tabs */\n.manage-cases-subtabs {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 16px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.manage-cases-subtab {\n  padding: 8px 18px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.manage-cases-subtab.active {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.manage-cases-subtab:hover:not(.active) {\n  border-color: #cbd5e1;\n  background: #f1f5f9;\n}\n\n/* Compact Cases List */\n.manage-cases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 0;\n  content-visibility: auto; /* Skips rendering items outside the viewport */\n  contain-intrinsic-size: 80px;\n}\n\n/* Compact Case Cards */\n.manage-case-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px 16px;\n  transition: all 0.2s ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 60px;\n}\n\n.manage-case-card:hover {\n  border-color: #3b82f6;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);\n  transform: translateY(-1px);\n}\n\n.manage-case-card.focused {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n  transform: translateY(-1px);\n}\n\n/* Disabled/Assigned state */\n.manage-case-card.assigned {\n  background: #f8f9fa;\n  opacity: 0.65;\n  cursor: not-allowed !important;\n  \n  &:hover {\n    border-color: #e2e8f0;\n    box-shadow: none;\n    transform: none;\n  }\n  \n  .case-checkbox {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n}\n\n.manage-case-checkbox {\n  position: static;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.case-checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--primary-color);\n}\n\n.manage-case-details {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 0;\n  min-height: auto;\n}\n\n.manage-case-main-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.manage-case-parties {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0 0 4px 0;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.manage-case-secondary-info {\n  display: flex;\n  gap: 16px;\n  margin: 0;\n  align-items: center;\n}\n\n.manage-case-info-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  padding: 0;\n  background: none;\n  border: none;\n  border-radius: 0;\n}\n\n.manage-case-label {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  min-width: auto;\n}\n\n.manage-case-info-item span:last-child {\n  color: #475569;\n  font-weight: 500;\n  font-size: 11px;\n}\n\n.manage-case-right-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0;\n  border: none;\n  flex-shrink: 0;\n}\n\n.manage-case-status {\n  display: flex;\n  align-items: center;\n}\n\n.manage-case-status-badge {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border: 1px solid;\n  white-space: nowrap;\n}\n\n.manage-case-status-badge.disposed {\n  background: #dcfce7;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.manage-case-status-badge.pending {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fde68a;\n}\n\n.manage-case-status-badge.na {\n  background: #f1f5f9;\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n\n.manage-case-date {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-size: 10px;\n}\n\n.manage-case-date .manage-case-label {\n  margin: 0;\n  font-size: 9px;\n}\n\n.manage-case-date span:last-child {\n  color: #1e293b;\n  font-weight: 600;\n  font-size: 10px;\n  white-space: nowrap;\n}\n.manage-cases-content {\n  position: relative; /* Critical for anchoring the loader */\n  min-height: 400px;  /* Critical: Prevents footer from jumping up */\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.manage-cases-loading {\n  position: absolute !important; /* Force it to sit ON TOP of the list */\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  \n  /* Make it a white transparent glass effect instead of the gray box */\n  background: rgba(255, 255, 255, 0.85) !important; \n  border: none !important; /* Remove the dashed border from existing styles */\n  border-radius: 0 !important;\n  \n  z-index: 50; /* Ensure it is above the rows */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Loading, Error, Empty States */\n\n.manage-cases-error,\n.manage-cases-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 20px;\n  text-align: center;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px dashed #cbd5e1;\n}\n\n.manage-cases-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #3b82f6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n.manage-cases-loading p,\n.manage-cases-empty p {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.manage-cases-error p {\n  color: #dc2626;\n  margin-bottom: 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.manage-cases-error button {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.manage-cases-error button:hover {\n  background: #b91c1c;\n}\n\n.options-courts{\n  display: flex;\n  gap: 6px;\n}\n\n/* Selection Counter Styles */\n.selection-counter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  flex-wrap: wrap; // Allow wrapping on smaller screens\n  gap: 8px;\n}\n\n/* Keyboard Navigation Hint */\n.keyboard-nav-hint {\n  padding: 6px 12px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  text-align: center;\n  \n  small {\n    color: #1e40af;\n    font-size: 11px;\n    font-weight: 500;\n  }\n  \n  kbd {\n    display: inline-block;\n    padding: 2px 6px;\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 1;\n    color: #1e293b;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 3px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    margin: 0 2px;\n  }\n}\n\n.selection-count {\n  font-weight: 600;\n  color: #475569;\n}\n\n.selection-actions {\n  display: flex;\n  gap: 8px; // ensures space between all action items\n  align-items: center;\n  margin-left: auto; // Push actions to the right\n}\n\n.select-all-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n/* Base styles for new action buttons */\n.select-all-cases-btn,\n.clear-page-btn {\n  padding: 4px 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n/* Specific styles for the new buttons */\n.select-all-cases-btn {\n  background: var(--compact-primary);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: #1d4ed8;\n  }\n}\n\n.clear-page-btn {\n  background: var(--compact-warning);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: var(--compact-warning-dark);\n  }\n}\n\n.clear-selection-btn {\n  padding: 4px 8px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.clear-selection-btn:hover {\n  background: #b91c1c;\n  transform: translateY(-1px);\n}\n\n/* Limit Exceeded Modal Styles */\n.limit-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(15, 23, 42, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n  padding: 16px;\n}\n\n.limit-modal-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  width: 100%;\n  max-width: 400px;\n  overflow: hidden;\n  animation: limit-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes limit-modal-appear {\n  from {\n    transform: translateY(20px) scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.limit-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #fef2f2;\n  border-bottom: 1px solid #fecaca;\n}\n\n.limit-modal-header h4 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #dc2626;\n  margin: 0;\n}\n\n.limit-modal-close {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  color: #dc2626;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.limit-modal-close:hover {\n  background: rgba(220, 38, 38, 0.1);\n}\n\n.limit-modal-content {\n  padding: 20px;\n  text-align: center;\n}\n\n.limit-modal-content p {\n  margin: 0 0 12px 0;\n  color: #64748b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.limit-modal-content p:last-child {\n  margin-bottom: 0;\n}\n\n.limit-modal-content strong {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.limit-modal-footer {\n  padding: 16px 20px;\n  background: #f8fafc;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.limit-modal-upgrade-btn {\n  padding: 8px 24px;\n  background: #ff7e5f;\n  background: linear-gradient(to right, #ff7e5f, #feb47b);\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.limit-modal-btn {\n  padding: 8px 24px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.limit-modal-btn:hover {\n  background: #b91c1c;\n  transform: translateY(-1px);\n}\n\n.sa-search-wrapper {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.sa-search-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.sa-search-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  background: white;\n}\n\n.sa-search-loading {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--primary-color);\n}\n\n.sa-spinner {\n  animation: spin 1s linear infinite;\n}\n\n.icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--border-light);\n  color: var(--text-medium);\n  position: relative;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n\n  &.active {\n    background: var(--primary-light);\n    color: var(--primary-color);\n    border: 1px solid var(--primary-color);\n  }\n\n  &.active-filter {\n    background: var(--primary-light-bg);\n  }\n\n  .filter-indicator {\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 8px;\n    height: 8px;\n    background-color: var(--primary-color);\n    border-radius: 50%;\n    border: 2px solid white;\n  }\n}\n\n/* Responsive Adjustments */\n@media (max-width: 1200px) {\n  .compact-modal-container {\n    max-width: 900px;\n  }\n\n  .image-style-stats-container {\n    flex-wrap: wrap;\n  }\n\n  .image-style-stat-card {\n    min-width: 160px;\n  }\n}\n\n@media (max-width: 900px) {\n  .manage-cases-section {\n    padding: 16px;\n  }\n  \n  .manage-cases-tabs {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .manage-cases-tab {\n    padding: 8px 12px;\n  }\n\n  .manage-case-details {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .manage-case-secondary-info {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  \n  .manage-case-right-info {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .image-style-stats-container {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .image-style-stat-card {\n    min-width: auto;\n  }\n\n  .compact-modal-content {\n    max-height: 1000px;\n  }\n}\n\n@media (max-width: 768px) {\n  .selection-counter {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .selection-actions {\n    width: 100%;\n    justify-content: flex-start;\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .manage-case-card {\n    padding: 10px 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .manage-case-checkbox {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n  }\n  \n  .manage-case-details {\n    width: 100%;\n    padding-right: 30px;\n  }\n  \n  .manage-case-parties {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: initial;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .selection-counter {\n    flex-direction: column;\n    gap: 8px;\n    align-items: stretch;\n    text-align: center;\n  }\n  \n  .clear-selection-btn {\n    width: 100%;\n    padding: 6px 12px;\n  }\n  \n  .limit-modal-container {\n    max-width: 350px;\n    margin: 0 16px;\n  }\n\n  .compact-modal-footer {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .manage-cases-pagination-compact {\n    width: 100%;\n  }\n\n  .footer-buttons {\n    width: 100%;\n    justify-content: stretch;\n  }\n\n  .footer-buttons button {\n    flex: 1;\n  }\n\n  .image-style-stat-card {\n    padding: 16px 12px;\n    gap: 10px;\n  }\n\n  .image-style-stat-card .stat-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .image-style-stat-card .stat-value {\n    font-size: 28px;\n  }\n}\n\n@media (max-width: 500px) {\n  .manage-cases-section {\n    padding: 16px;\n  }\n\n  .manage-cases-tabs {\n    flex-direction: column;\n  }\n\n  .manage-cases-tab {\n    text-align: center;\n  }\n\n  .manage-case-card {\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
